// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/registration/register/documents/firstparty/v1/update_document.proto

/* eslint-disable */
import { ApiDocType, apiDocTypeFromJSON, apiDocTypeToJSON, ApiDocument } from "./document";

/** Request message for updating a document */
export interface ApiUpdateDocumentRequest {
  /** The ID of the document to update */
  readonly id: string;
  /** The document fields to update */
  readonly document: ApiDocumentInput | null;
}

/** Input message for updating a document */
export interface ApiDocumentInput {
  /** Unique identifier of the document */
  readonly id?:
    | string
    | null
    | undefined;
  /** Type of the subject the document belongs to (Organization or Stakeholder) */
  readonly subjectType?:
    | string
    | null
    | undefined;
  /** Unique identifier of the subject the document belongs to */
  readonly subjectId?:
    | string
    | null
    | undefined;
  /** Type of the document */
  readonly docType?:
    | ApiDocType
    | null
    | undefined;
  /** Subtype of the document (e.g., eu_passport) */
  readonly docSubtype?:
    | string
    | null
    | undefined;
  /** Name of the document file */
  readonly name?:
    | string
    | null
    | undefined;
  /** MIME content type of the document */
  readonly contentType?:
    | string
    | null
    | undefined;
  /** Size of the document in bytes */
  readonly size?:
    | number
    | null
    | undefined;
  /** URL to download the document */
  readonly url?: string | null | undefined;
}

/** Response message for updating a document */
export interface ApiUpdateDocumentResponse {
  /** The updated document */
  readonly document: ApiDocument | null;
}

/** Error codes for UpdateDocument operation */
export interface ApiUpdateDocumentErrors {
}

/** Not found error codes */
export const ApiUpdateDocumentErrorsNotFoundError = {
  /** NOT_FOUND_ERROR_UNSPECIFIED - Unspecified not found error */
  NOT_FOUND_ERROR_UNSPECIFIED: "NOT_FOUND_ERROR_UNSPECIFIED",
  /** NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED - Document not found or unauthorized */
  NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED: "NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED",
} as const;

export type ApiUpdateDocumentErrorsNotFoundError =
  typeof ApiUpdateDocumentErrorsNotFoundError[keyof typeof ApiUpdateDocumentErrorsNotFoundError];

export namespace ApiUpdateDocumentErrorsNotFoundError {
  export type NOT_FOUND_ERROR_UNSPECIFIED = typeof ApiUpdateDocumentErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED;
  export type NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED =
    typeof ApiUpdateDocumentErrorsNotFoundError.NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED;
}

export function apiUpdateDocumentErrorsNotFoundErrorFromJSON(object: any): ApiUpdateDocumentErrorsNotFoundError {
  switch (object) {
    case 0:
    case "NOT_FOUND_ERROR_UNSPECIFIED":
      return ApiUpdateDocumentErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED;
    case 1:
    case "NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED":
      return ApiUpdateDocumentErrorsNotFoundError.NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED;
    default:
      return ApiUpdateDocumentErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED;
  }
}

export function apiUpdateDocumentErrorsNotFoundErrorToJSON(object: ApiUpdateDocumentErrorsNotFoundError): string {
  switch (object) {
    case ApiUpdateDocumentErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED:
      return "NOT_FOUND_ERROR_UNSPECIFIED";
    case ApiUpdateDocumentErrorsNotFoundError.NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED:
      return "NOT_FOUND_ERROR_NOT_FOUND_OR_UNAUTHORIZED";
    default:
      return "NOT_FOUND_ERROR_UNSPECIFIED";
  }
}

/** Method not allowed error codes */
export const ApiUpdateDocumentErrorsMethodNotAllowedError = {
  /** METHOD_NOT_ALLOWED_ERROR_UNSPECIFIED - Unspecified method not allowed error */
  METHOD_NOT_ALLOWED_ERROR_UNSPECIFIED: "METHOD_NOT_ALLOWED_ERROR_UNSPECIFIED",
  /** METHOD_NOT_ALLOWED_ERROR_DOCUMENT_NOT_IN_DRAFT - Document cannot be updated because registration is not in draft status */
  METHOD_NOT_ALLOWED_ERROR_DOCUMENT_NOT_IN_DRAFT: "METHOD_NOT_ALLOWED_ERROR_DOCUMENT_NOT_IN_DRAFT",
} as const;

export type ApiUpdateDocumentErrorsMethodNotAllowedError =
  typeof ApiUpdateDocumentErrorsMethodNotAllowedError[keyof typeof ApiUpdateDocumentErrorsMethodNotAllowedError];

export namespace ApiUpdateDocumentErrorsMethodNotAllowedError {
  export type METHOD_NOT_ALLOWED_ERROR_UNSPECIFIED =
    typeof ApiUpdateDocumentErrorsMethodNotAllowedError.METHOD_NOT_ALLOWED_ERROR_UNSPECIFIED;
  export type METHOD_NOT_ALLOWED_ERROR_DOCUMENT_NOT_IN_DRAFT =
    typeof ApiUpdateDocumentErrorsMethodNotAllowedError.METHOD_NOT_ALLOWED_ERROR_DOCUMENT_NOT_IN_DRAFT;
}

export function apiUpdateDocumentErrorsMethodNotAllowedErrorFromJSON(
  object: any,
): ApiUpdateDocumentErrorsMethodNotAllowedError {
  switch (object) {
    case 0:
    case "METHOD_NOT_ALLOWED_ERROR_UNSPECIFIED":
      return ApiUpdateDocumentErrorsMethodNotAllowedError.METHOD_NOT_ALLOWED_ERROR_UNSPECIFIED;
    case 1:
    case "METHOD_NOT_ALLOWED_ERROR_DOCUMENT_NOT_IN_DRAFT":
      return ApiUpdateDocumentErrorsMethodNotAllowedError.METHOD_NOT_ALLOWED_ERROR_DOCUMENT_NOT_IN_DRAFT;
    default:
      return ApiUpdateDocumentErrorsMethodNotAllowedError.METHOD_NOT_ALLOWED_ERROR_UNSPECIFIED;
  }
}

export function apiUpdateDocumentErrorsMethodNotAllowedErrorToJSON(
  object: ApiUpdateDocumentErrorsMethodNotAllowedError,
): string {
  switch (object) {
    case ApiUpdateDocumentErrorsMethodNotAllowedError.METHOD_NOT_ALLOWED_ERROR_UNSPECIFIED:
      return "METHOD_NOT_ALLOWED_ERROR_UNSPECIFIED";
    case ApiUpdateDocumentErrorsMethodNotAllowedError.METHOD_NOT_ALLOWED_ERROR_DOCUMENT_NOT_IN_DRAFT:
      return "METHOD_NOT_ALLOWED_ERROR_DOCUMENT_NOT_IN_DRAFT";
    default:
      return "METHOD_NOT_ALLOWED_ERROR_UNSPECIFIED";
  }
}

/** Validation error codes */
export const ApiUpdateDocumentErrorsUnprocessableEntityError = {
  /** UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED - Unspecified validation error */
  UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED: "UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED",
  /** UNPROCESSABLE_ENTITY_ERROR_VALIDATION_FAILED - Validation failed */
  UNPROCESSABLE_ENTITY_ERROR_VALIDATION_FAILED: "UNPROCESSABLE_ENTITY_ERROR_VALIDATION_FAILED",
} as const;

export type ApiUpdateDocumentErrorsUnprocessableEntityError =
  typeof ApiUpdateDocumentErrorsUnprocessableEntityError[keyof typeof ApiUpdateDocumentErrorsUnprocessableEntityError];

export namespace ApiUpdateDocumentErrorsUnprocessableEntityError {
  export type UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED =
    typeof ApiUpdateDocumentErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED;
  export type UNPROCESSABLE_ENTITY_ERROR_VALIDATION_FAILED =
    typeof ApiUpdateDocumentErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_VALIDATION_FAILED;
}

export function apiUpdateDocumentErrorsUnprocessableEntityErrorFromJSON(
  object: any,
): ApiUpdateDocumentErrorsUnprocessableEntityError {
  switch (object) {
    case 0:
    case "UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED":
      return ApiUpdateDocumentErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED;
    case 1:
    case "UNPROCESSABLE_ENTITY_ERROR_VALIDATION_FAILED":
      return ApiUpdateDocumentErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_VALIDATION_FAILED;
    default:
      return ApiUpdateDocumentErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED;
  }
}

export function apiUpdateDocumentErrorsUnprocessableEntityErrorToJSON(
  object: ApiUpdateDocumentErrorsUnprocessableEntityError,
): string {
  switch (object) {
    case ApiUpdateDocumentErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED:
      return "UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED";
    case ApiUpdateDocumentErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_VALIDATION_FAILED:
      return "UNPROCESSABLE_ENTITY_ERROR_VALIDATION_FAILED";
    default:
      return "UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED";
  }
}

export const ApiUpdateDocumentRequest: MessageFns<ApiUpdateDocumentRequest> = {
  fromJSON(object: any): ApiUpdateDocumentRequest {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      document: isSet(object.document) ? ApiDocumentInput.fromJSON(object.document) : null,
    };
  },

  toJSON(message: ApiUpdateDocumentRequest): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    if (message.document !== undefined && message.document !== null) {
      obj.document = ApiDocumentInput.toJSON(message.document);
    }
    return obj;
  },
};

export const ApiDocumentInput: MessageFns<ApiDocumentInput> = {
  fromJSON(object: any): ApiDocumentInput {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : null,
      subjectType: isSet(object.subject_type) ? globalThis.String(object.subject_type) : null,
      subjectId: isSet(object.subject_id) ? globalThis.String(object.subject_id) : null,
      docType: isSet(object.doc_type) ? apiDocTypeFromJSON(object.doc_type) : null,
      docSubtype: isSet(object.doc_subtype) ? globalThis.String(object.doc_subtype) : null,
      name: isSet(object.name) ? globalThis.String(object.name) : null,
      contentType: isSet(object.content_type) ? globalThis.String(object.content_type) : null,
      size: isSet(object.size) ? globalThis.Number(object.size) : null,
      url: isSet(object.url) ? globalThis.String(object.url) : null,
    };
  },

  toJSON(message: ApiDocumentInput): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    if (message.subjectType !== undefined && message.subjectType !== null) {
      obj.subject_type = message.subjectType;
    }
    if (message.subjectId !== undefined && message.subjectId !== null) {
      obj.subject_id = message.subjectId;
    }
    if (message.docType !== undefined && message.docType !== null) {
      obj.doc_type = apiDocTypeToJSON(message.docType);
    }
    if (message.docSubtype !== undefined && message.docSubtype !== null) {
      obj.doc_subtype = message.docSubtype;
    }
    if (message.name !== undefined && message.name !== null) {
      obj.name = message.name;
    }
    if (message.contentType !== undefined && message.contentType !== null) {
      obj.content_type = message.contentType;
    }
    if (message.size !== undefined && message.size !== null) {
      obj.size = Math.round(message.size);
    }
    if (message.url !== undefined && message.url !== null) {
      obj.url = message.url;
    }
    return obj;
  },
};

export const ApiUpdateDocumentResponse: MessageFns<ApiUpdateDocumentResponse> = {
  fromJSON(object: any): ApiUpdateDocumentResponse {
    return { document: isSet(object.document) ? ApiDocument.fromJSON(object.document) : null };
  },

  toJSON(message: ApiUpdateDocumentResponse): unknown {
    const obj: any = {};
    if (message.document !== undefined && message.document !== null) {
      obj.document = ApiDocument.toJSON(message.document);
    }
    return obj;
  },
};

export const ApiUpdateDocumentErrors: MessageFns<ApiUpdateDocumentErrors> = {
  fromJSON(_: any): ApiUpdateDocumentErrors {
    return {};
  },

  toJSON(_: ApiUpdateDocumentErrors): unknown {
    const obj: any = {};
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
